export default __webpack_public_path__ + "static/media/room-mel-3.52eee453.webp";